export enum MissionType {
  COLONIZATION = 'colonization',
  STAY = 'stay',
  TRANSPORT = 'transport',
  MOVE = 'move',
  SPY = 'spy',
  ATTACK = 'attack',
  RECYCLE = 'recycle',
}
